import React from 'react';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { Box, Button, Divider, Menu, MenuItem, Typography } from '@mui/material';
import { useI18n } from "@haohan/root-locales";
import { papi } from '@haohan-frontend/papi';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppCtx } from '../../AppStore';
import { SiteRouterButtonLink } from '../../components/RouterButtonLink';

export const AccountButton: React.FC = () => {
    const { t, lang } = useI18n();
    const navigate = useNavigate();
    const { activeUser } = useAppCtx();
    const location = useLocation();
    const [open, setOpen] = React.useState(false);
    const buttonRef = React.useRef<HTMLButtonElement>();
    let content: React.ReactNode = null;
    if (activeUser) {
        return (
            <>
                <Button
                    ref={buttonRef}
                    size="small"
                    variant="outlined"
                    color='primary'
                    onClick={() => setOpen(true)}
                    startIcon={<PersonOutlineIcon fontSize="small" />}
                >
                    {t('Account')}
                </Button>
                <Menu
                    MenuListProps={{dense: true}}
                    open={open}
                    anchorPosition={{
                        top: -10,
                        left: 0
                    }}
                    transformOrigin={{
                        horizontal: 'right',
                        vertical: 'top',
                    }}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right'
                    }}
                    anchorEl={buttonRef.current}
                    onClose={() => setOpen(false)}
                >
                    <Box px={2} pb={0.5} fontSize={14}>
                        <Typography
                            fontSize={14}
                            fontWeight='bold'
                            display='block'
                        >
                            {activeUser.firstName}
                        </Typography>
                        <Typography
                            fontSize={13}
                            display='block'
                            maxWidth={190}
                            overflow='hidden'
                            textOverflow='ellipsis'
                            color='GrayText'
                        >
                            {activeUser.email}
                        </Typography>
                    </Box>
                    <Divider/>
                    {[
                        {
                            title: t('Documents'),
                            key: 'documents'
                        },
                        {
                            title: t('My Games'),
                            key: 'games'
                        },
                        {
                            title: t('Account settings'),
                            key: 'settings'
                        },
                    ].map(it => {
                        return (
                            <MenuItem
                                key={it.key}
                                onClick={() => {
                                    navigate(`/${lang}/my/${it.key}`);
                                    setOpen(false);
                                }}
                            >
                                {it.title}
                            </MenuItem>
                        );
                    })}
                    <Divider />
                    <MenuItem onClick={async () => {
                        await papi.auth.logout();
                        window.location.reload();
                    }}>
                        {t('actions.Logout')}
                    </MenuItem>
                </Menu>
            </>
        );
    } else {
        return (
            <SiteRouterButtonLink
                size='small'
                to={`/auth?next=${encodeURIComponent(location.pathname)}`}
                variant='outlined'
            >
                {t("actions.Sign in")}
            </SiteRouterButtonLink>
        );
    }
}
